import { OpenNewTabTargetType } from '@voltmoney/types';
import { ButtonTypeTokens, IconTokens, InputStateToken, } from '@voltmoney/schema';
import { Links, PartnerAccountType, partnerAffiliateHelpLineNumber, PartnerFaqLink, partnerHelpLineNumber, PartnerLink, SDKInvestwellPartnerHelpLineNumber, VoltWebSiteBaseLink, WhatsAppLink } from '../../configs/constants';
import { ACTION } from './types';
import { api, partnerApi, StoreKey } from '../../configs/api';
import { getAppHeader, getAuthHeaders, RegexConfig } from '../../configs/config';
import { ROUTE } from '../../routes';
import SharedPropsService from '../../SharedPropsService';
import sharedPropsService from '../../SharedPropsService';
import { getParamsLink, getPrivacyLinks, getTermsLinks, isFromAndroidWebview, partnerNavigate } from '../../configs/utils';
import { isNull } from 'lodash';
import md5 from 'md5';
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
let phoneNumber = '';
let isWhatsAppEnabled = true;
let otpValue = '';
let name = '';
let email = '';
let companyName = '';
let city = '';
let password = '';
let hasTextChanged = false;
let isFromEmpanelment = false;
let arnNo = '';
let referredPartner = false;
let isFromLoginWithOTP = false;
export const TestAction = async (action, _datastore, { navigate }) => {
    console.warn('**** Test Action Triggered ****', action);
};
export const PhoneNumberAction = async (action, _datastore, { setDatastore }) => {
    if (hasTextChanged) {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "errorauthTextstack", {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "errorTextSpaceStack", {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "empanelStackfinal", {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "empanelSpaceStack", {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithOTPButtonStack", {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "getLoginWithPasswordSpaceStack", {
            hide: false
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordButton", {
            type: ButtonTypeTokens.LargeOutline
        });
        hasTextChanged = false;
    }
    console.warn('**** PhoneNumberAction Triggered ****', action);
    phoneNumber = action.payload.value;
    if (phoneNumber !== '' && phoneNumber.length >= 10 && password !== '') {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordButton", {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordButton", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const getPassword = async (action, _datastore, { setDatastore }) => {
    console.warn('**** PasswordAction Triggered ****', action);
    password = action.payload.value;
    if (phoneNumber !== '' && phoneNumber.length >= 10 && password !== '') {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordButton", {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordButton", {
            type: ButtonTypeTokens.LargeOutline
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "passwordInput", {
            state: InputStateToken.DEFAULT,
            caption: { error: '' }
        });
    }
};
export const ToggleCTA = async (action, _datastore, { setDatastore }) => {
    console.warn('**** ToggleCTA Triggered ****', action);
    await setDatastore(ROUTE.PARTNER_SIGNUP, "signupComponentPhoneNumber", {
        value: `${phoneNumber}`,
        state: action.payload.value
            ? InputStateToken.SUCCESS
            : InputStateToken.DEFAULT
    });
    await setDatastore(action.routeId, action.payload.targetWidgetId, {
        type: action.payload.value
            ? ButtonTypeTokens.LargeFilled
            : ButtonTypeTokens.LargeOutline,
    });
    await setDatastore(action.routeId, "loginWithPassword", {
        type: action.payload.value
            ? ButtonTypeTokens.LargeSoftFilled
            : ButtonTypeTokens.LargeOutline,
    });
};
export const GoToPrivacy = async (action, _datastore, { openNewTab }) => {
    console.warn('**** GoToPrivacy Triggered ****', action);
    openNewTab(Links.VOLT_PRIVACY, OpenNewTabTargetType.blank);
};
export const WhatsappToggle = async (action, _datastore) => {
    console.warn('**** WhatsappToggle Triggered ****', action);
    isWhatsAppEnabled = action.payload.value;
};
export const GetOtp = async (action, _datastore, { setDatastore, network, instrumentTrack }) => {
    console.warn('**** GetOtp Triggered ****', action);
    const urlPath = action.payload.path;
    if (phoneNumber.length === 10) {
        await setDatastore(action.routeId, action.payload.widgetId, {
            loading: true,
        });
        const Authheader = await getAuthHeaders();
        Authheader['X-EntityType'] = 'PARTNER';
        Authheader['X-AppPlatform'] = await sharedPropsService.getAppPlatform();
        console.log('get params 123: ', getParamsLink(urlPath));
        const response = await network.get(`${partnerApi.login}+91${phoneNumber}${getParamsLink(urlPath)}`, {
            headers: Authheader,
        }, async () => {
            return;
        }, {
            isPartnerPlatform: true,
        });
        if (response?.status === 200) {
            await setDatastore(action.routeId, action.payload.widgetId, {
                loading: false,
            });
            if (action.payload.isResend == false) {
                await setDatastore(action.routeId, 'signupComponentContainer', {
                    hide: true,
                });
                await setDatastore(action.routeId, 'otpComponentContainer', {
                    hide: false,
                });
                await setDatastore(action.routeId, 'subTitle2', {
                    label: `${phoneNumber}`,
                });
                await setDatastore(ROUTE.PARTNER_SIGNUP, "input", {
                    state: InputStateToken.DEFAULT,
                });
            }
            if (action.payload.isResend == false) {
                await setDatastore(action.routeId, 'signupComponentPhoneNumber', {
                    state: InputStateToken.SUCCESS,
                });
            }
            if (action.payload.isResend === true) {
                instrumentTrack("RESEND_OTP_BUTTON_CLICKED");
            }
        }
        else {
            await setDatastore(ROUTE.PARTNER_SIGNUP, "signupComponentPhoneNumber", {
                state: InputStateToken.ERROR,
                caption: { error: response?.response?.data?.voltErrorCode?.includes("ACCOUNT_BLOCKED_FROM_OTP") ? "OTP limit exceeded. Please retry in 5 minutes." : response.response.data.message }
            });
            await setDatastore(action.routeId, action.payload.widgetId, {
                loading: false,
            });
        }
    }
    else {
        await setDatastore(action.routeId, action.payload.widgetId, {
            loading: false,
        });
        await setDatastore(action.routeId, 'signupComponentPhoneNumber', {
            state: InputStateToken.ERROR,
        });
    }
};
export const GoToPhoneNumber = async (action, _datastore, { setDatastore, instrumentTrack }) => {
    password = '';
    console.warn('**** GoToPhoneNumber Triggered ****', action);
    await setDatastore(action.routeId, 'signupComponentContainer', {
        hide: false,
    });
    await setDatastore(action.routeId, 'otpComponentContainer', {
        hide: true,
    });
    await setDatastore(action.routeId, 'errorTextSpaceStack', {
        hide: true,
    });
    await setDatastore(action.routeId, 'errorauthTextstack', {
        hide: true,
    });
    await setDatastore(action.routeId, 'loginWithPasswordButton', {
        type: ButtonTypeTokens.LargeOutline
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "passwordInput", {
        caption: { error: '' },
        state: InputStateToken.DEFAULT
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "errorSpaceStack", {
        hide: true
    });
    if (isFromEmpanelment) {
        if (isFromLoginWithOTP) {
            await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithOTPButtonStack", {
                hide: true
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "getLoginWithPasswordSpaceStack", {
                hide: false
            });
            isFromLoginWithOTP = false;
        }
        else {
            await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithOTPButtonStack", {
                hide: true
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "getLoginWithPasswordSpaceStack", {
                hide: true
            });
        }
        isFromEmpanelment = false;
    }
    console.log("phoneNumber123: ", phoneNumber);
    await setDatastore(action.routeId, 'signupComponentPhoneNumber', {
        value: `${phoneNumber}`,
        action: {
            type: ACTION.PHONE_NUMBER,
            payload: {
                value: `${phoneNumber}`,
                widgetId: 'signupComponentPhoneNumber',
            },
            routeId: ROUTE.PARTNER_SIGNUP,
        },
    });
    instrumentTrack("EDIT_PHONE_BUTTON_CLICKED");
};
export const VerifyOtp = async (action, _datastore, { network, setDatastore, navigateToBase, asyncStorage, analytics }) => {
    console.warn('**** VerifyOtp Triggered ****', action);
    otpValue = action.payload.value;
    const refCode = action.payload.refCode;
    const referredPartner = action.payload.referredPartner;
    const Authheader = await getAuthHeaders();
    const partnerAccountType = action?.payload?.partnerAccountType;
    Authheader['X-EntityType'] = 'PARTNER';
    Authheader['X-AppPlatform'] = await sharedPropsService.getAppPlatform();
    if (otpValue.length === 4) {
        const response = await network.post(`${partnerApi.verifyOtp}`, {
            otp: otpValue,
            phoneNo: `+91${phoneNumber}`,
        }, {
            headers: Authheader
        }, async () => {
            return;
        }, {
            isPartnerPlatform: true,
        });
        if (response?.data?.status === 'SUCCESS') {
            // save the jwt token
            await SharedPropsService.setToken(response.data.jwt);
            asyncStorage.set(StoreKey.accessToken, response.data.jwt);
            // set the otp component to success
            await setDatastore(action.routeId, action.payload.widgetId, {
                state: InputStateToken.SUCCESS,
            });
            const header = await getAppHeader();
            //set the user context
            const data = refCode
                ? {
                    partnerAccountType: partnerAccountType ? partnerAccountType : 'INDIVIDUAL',
                    onboardingPartnerCode: refCode,
                }
                : {
                    partnerAccountType: partnerAccountType ? partnerAccountType : 'INDIVIDUAL',
                };
            const userContextResponse = await network.post(partnerApi.userContext, data, { headers: header }, async () => {
                return;
            }, {
                isPartnerPlatform: true,
            });
            await sharedPropsService.setUser(userContextResponse.data);
            await asyncStorage.set(StoreKey.userContext, JSON.stringify(userContextResponse.data));
            const user = userContextResponse.data;
            const partnerEmail = user.linkedPartnerAccounts[0].accountHolderEmail;
            console.log('partner Email: ', partnerEmail);
            //show additional details screen
            await setDatastore(action.routeId, 'signupComponentContainer', {
                hide: true,
            });
            await setDatastore(action.routeId, 'otpComponentContainer', {
                hide: true,
            });
            //if partner Email is not present the show additional details container
            if (isNull(partnerEmail)) {
                analytics('mfd_empanelment_started', {});
                await setDatastore(ROUTE.PARTNER_SIGNUP, 'additionalDetailContainer', {
                    hide: false,
                });
            }
            else {
                // we will navigate to dashboard
                // console.log("referredPartner verify otp 123: ", referredPartner);
                if (referredPartner) {
                    await partnerNavigate(ROUTE.PARTNER_REFERRED_PARTNER);
                }
                else {
                    const getActiveIndexTab = await AsyncStorage?.getItem("activeIndexTab");
                    if (getActiveIndexTab !== undefined && getActiveIndexTab !== null) {
                        if (getActiveIndexTab === 'interest' || getActiveIndexTab === 'renewal' || getActiveIndexTab === 'shortfall' || getActiveIndexTab === 'all') {
                            await partnerNavigate(ROUTE.PARTNER_ACTIVE_CUSTOMER);
                        }
                        else
                            await partnerNavigate(ROUTE.PARTNER_DASHBOARD_V2);
                    }
                    else
                        await partnerNavigate(ROUTE.PARTNER_DASHBOARD_V2);
                }
            }
        }
        else {
            if (response?.response?.status === 400) {
                if (response?.response?.data?.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
                    await setDatastore(ROUTE.PARTNER_SIGNUP, "input", {
                        state: InputStateToken.DISABLED,
                        caption: { error: "OTP limit exceeded. Please try again after 5 minutes." },
                        otpLimitExceeded: true
                    });
                }
                else {
                    await setDatastore(ROUTE.PARTNER_SIGNUP, "input", {
                        state: InputStateToken.ERROR,
                        caption: { error: response.response.data.message }
                    });
                }
            }
        }
    }
};
export const OnChangeInput = async (action, _datastore, { setDatastore }) => {
    console.warn('**** OnChangeInput Action Triggered ****', action);
    if (action.payload.widgetId === 'nameInput') {
        name = action.payload.value.trim();
    }
    if (action.payload.widgetId === 'emailInput') {
        email = action.payload.value.trim();
    }
    if (action.payload.widgetId === 'companyNameInput') {
        companyName = action.payload.value.trim();
    }
    if (action.payload.widgetId === 'additionalCityInput') {
        city = action.payload.value.trim();
    }
    const emailRegex = new RegExp(RegexConfig.NEW_EMAIL);
    const isEmailValid = emailRegex.test(email);
    const alphabetsSpecialCharacterRegex = /^[A-Za-z. ]+$/;
    const onlyAlphabetRegex = /^[A-Za-z ]+$/;
    if (name.length > 0 && !alphabetsSpecialCharacterRegex.test(name)) {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "nameInput", {
            state: InputStateToken.ERROR,
            caption: { error: 'Please enter a valid name' }
        });
    }
    else {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "nameInput", {
            state: InputStateToken.DEFAULT,
            caption: { error: '' }
        });
    }
    if (city.length > 0 && !onlyAlphabetRegex.test(city)) {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "additionalCityInput", {
            state: InputStateToken.ERROR,
            caption: { error: 'Please enter a valid city name' }
        });
    }
    else {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "additionalCityInput", {
            state: InputStateToken.DEFAULT,
            caption: { error: '' }
        });
    }
    if (email.length > 0 && !emailRegex.test(email)) {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "emailInput", {
            state: InputStateToken.ERROR,
            caption: { error: 'Please enter a valid email' }
        });
    }
    else {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "emailInput", {
            state: InputStateToken.DEFAULT,
            caption: { error: '' }
        });
    }
    if (name && alphabetsSpecialCharacterRegex.test(name) && isEmailValid && city && onlyAlphabetRegex.test(city)) {
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'additionalDetailContinueBtn', {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    else {
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'additionalDetailContinueBtn', {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
};
export const DisableSubmit = async (action, _datastore, { setDatastore }) => {
    console.warn('**** DisableSubmit Action Triggered ****', action);
    await setDatastore(ROUTE.PARTNER_SIGNUP, "additionalDetailContinueBtn", {
        type: ButtonTypeTokens.LargeOutline,
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "emailInput", {
        state: InputStateToken.ERROR,
        caption: { error: 'Please enter a valid email' }
    });
};
export const SuccessEmail = async (action, _datastore, { setDatastore }) => {
    console.warn('**** SuccessEmail Action Triggered ****', action);
    await setDatastore(ROUTE.PARTNER_SIGNUP, "emailInput", {
        state: InputStateToken.SUCCESS
    });
};
export const loginWithOTPRedirect = async (action, _datastore, { setDatastore, network, instrumentTrack, ...props }) => {
    isFromLoginWithOTP = true;
    if (phoneNumber.length !== 10) {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordButtonStack", {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithOTPButtonStack", {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "getLoginWithPasswordSpaceStack", {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "passwordInputStack", {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "signupComponentContainerSpace0", {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "whatsappStack1", {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "getOtpBtnStack", {
            hide: false
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordStack", {
            hide: false
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "getOtpSpacestack", {
            hide: false
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "whatsappStack", {
            hide: false
        });
    }
    else {
        await GetOtp(action, {}, { setDatastore, network, instrumentTrack, ...props });
    }
};
export const loginPassword = async (action, _datastore, { network, setDatastore, asyncStorage, analytics }) => {
    const md5Password = md5(password);
    const authResponse = await network.post(`${partnerApi.authv2}`, {
        phoneNumber: `+91${phoneNumber}`,
        passwordHash: md5Password
    }, { headers: await getAuthHeaders() });
    if (authResponse.status === 200) {
        await SharedPropsService.setToken(authResponse.data.jwt);
        await asyncStorage.set(StoreKey.accessToken, authResponse.data.jwt);
        const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
        await sharedPropsService.setUser(userContextResponse.data);
        const getActiveIndexTab = await AsyncStorage?.getItem("activeIndexTab");
        if (getActiveIndexTab !== undefined && getActiveIndexTab !== null) {
            if (getActiveIndexTab === 'interest' || getActiveIndexTab === 'renewal' || getActiveIndexTab === 'shortfall' || getActiveIndexTab === 'all') {
                await partnerNavigate(ROUTE.PARTNER_ACTIVE_CUSTOMER);
            }
            else
                await partnerNavigate(ROUTE.PARTNER_DASHBOARD_V2);
        }
        else
            await partnerNavigate(ROUTE.PARTNER_DASHBOARD_V2);
    }
    else {
        if (authResponse?.response.data?.voltErrorCode === "INCORRECT_PASSWORD_FOR_PARTNER") {
            await setDatastore(ROUTE.PARTNER_SIGNUP, "passwordInput", {
                caption: { error: 'Invalid password' },
                state: InputStateToken.ERROR
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "errorSpaceStack", {
                hide: false
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordButton", {
                type: ButtonTypeTokens.LargeOutline
            });
        }
        else if (authResponse?.response.data?.voltErrorCode === "PARTNER_ACCOUNT_NOT_FOUND") {
            hasTextChanged = true;
            await setDatastore(ROUTE.PARTNER_SIGNUP, "empanelStackfinal", {
                hide: false
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "empanelSpaceStack", {
                hide: false
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithOTPButtonStack", {
                hide: true
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "getLoginWithPasswordSpaceStack", {
                hide: true
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "getLoginWithOtpSpaceStack", {
                hide: true
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "passwordInput", {
                caption: { error: 'User not found with the given detail' },
                state: InputStateToken.ERROR
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "errorSpaceStack", {
                hide: false
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordButton", {
                type: ButtonTypeTokens.LargeOutline
            });
        }
        else {
            await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordButton", {
                type: ButtonTypeTokens.LargeFilled
            });
            await setDatastore(ROUTE.PARTNER_SIGNUP, "passwordInput", {
                caption: { error: '' },
                state: InputStateToken.DEFAULT
            });
        }
    }
};
export const loginWithPasswordEntry = async (action, _datastore, { setDatastore, instrumentTrack }) => {
    instrumentTrack("LOGIN_WITH_PASSWORD_BUTTON_CLICKED");
    await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordButtonStack", {
        hide: false
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithOTPButtonStack", {
        hide: false
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "getLoginWithPasswordSpaceStack", {
        hide: false
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "getLoginWithOtpSpaceStack", {
        hide: false
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "passwordInputStack", {
        hide: false
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "whatsappStack1", {
        hide: false
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "getOtpBtnStack", {
        hide: true
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordStack", {
        hide: true
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "getOtpSpacestack", {
        hide: true
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "whatsappStack", {
        hide: true
    });
    if (isFromEmpanelment) {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "passwordInput", {
            state: InputStateToken.DEFAULT,
            caption: { error: '' }
        });
    }
};
export const CitySelectionNav = async (action, _datastore, { setDatastore }) => {
    console.warn('**** CitySelectionNav Triggered ****', action);
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'additionalDetailContainer', {
        hide: true,
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'citySelectionContainer', {
        hide: false,
    });
};
export const SelectCity = async (action, _datastore, { setDatastore }) => {
    console.warn('**** SelectCity Triggered ****', action);
    //@ts-ignore
    city = action.payload.value;
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'nameInput', {
        value: `${name}`,
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'emailInput', {
        value: `${email}`,
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'companyNameInput', {
        value: `${companyName}`,
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'additionalCityInput', {
        value: `${city}`,
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'additionalDetailContainer', {
        hide: false,
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'citySelectionContainer', {
        hide: true,
    });
};
export const AdditionalDetailsSubmit = async (action, _datastore, { setDatastore, navigate, network, asyncStorage, analytics }) => {
    console.warn('**** AdditionalDetailsSubmit Triggered ****', action);
    referredPartner = action?.payload?.referredPartner;
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'additionalDetailContainer', { hide: true });
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'arnDetailsContainer', { hide: false });
};
export const GoToHome = async (action, _datastore, { openNewTab, asyncStorage }) => {
    const partnerAccountType = action?.payload?.partnerAccountType ?
        action?.payload?.partnerAccountType :
        JSON.parse(await asyncStorage.get(StoreKey.userContext))?.linkedPartnerAccounts[0]?.partnerAccountType ?
            JSON.parse(await asyncStorage.get(StoreKey.userContext))?.linkedPartnerAccounts[0]?.partnerAccountType : undefined;
    if (Platform.OS === 'web') {
        if (isFromAndroidWebview()) {
            return;
        }
        ;
        const url = window.location.href;
        if (partnerAccountType && partnerAccountType === PartnerAccountType.AFFILIATE) {
            openNewTab(`${VoltWebSiteBaseLink}/affiliate${getParamsLink(url)}`, OpenNewTabTargetType.self);
        }
        else {
            openNewTab(`${PartnerLink}${getParamsLink(url)}`, OpenNewTabTargetType.self);
        }
    }
};
export const empanelUs = async (action, _datastore, { setDatastore }) => {
    isFromEmpanelment = true;
    await setDatastore(ROUTE.PARTNER_SIGNUP, "getOtpBtnStack", {
        hide: false
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "getOtpSpacestack", {
        hide: false
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordStack", {
        hide: false
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "whatsappStack", {
        hide: false
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPasswordButtonStack", {
        hide: true
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithOTPButtonStack", {
        hide: true
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "getLoginWithPasswordSpaceStack", {
        hide: true
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "empanelStackfinal", {
        hide: true
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "empanelSpaceStack", {
        hide: true
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "passwordInputStack", {
        hide: true
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, "whatsappStack1", {
        hide: true
    });
    if (phoneNumber && phoneNumber.length === 10) {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "getOtpBtn", {
            type: ButtonTypeTokens.LargeFilled
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPassword", {
            type: ButtonTypeTokens.LargeSoftFilled
        });
    }
    else {
        await setDatastore(ROUTE.PARTNER_SIGNUP, "getOtpBtn", {
            type: ButtonTypeTokens.LargeOutline
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, "loginWithPassword", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const GoToFaq = async (action, _datastore, { openNewTab, instrumentTrack, asyncStorage }) => {
    instrumentTrack("FAQ_BUTTON_CLICKED");
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const partnerAccountType = user?.linkedPartnerAccounts[0]?.partnerAccountType;
    switch (partnerAccountType) {
        case PartnerAccountType.AFFILIATE:
            openNewTab(`${VoltWebSiteBaseLink}affiliate#faq_affiliate`, OpenNewTabTargetType.blank);
            break;
        default:
            openNewTab(`${PartnerFaqLink}`, OpenNewTabTargetType.blank);
            break;
    }
};
export const GoToWhatsapp = async (action, _datastore, { openNewTab, instrumentTrack, asyncStorage }) => {
    instrumentTrack("CONTACT_VIA_WA_BUTTON_CLICKED");
    const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const platformCode = _user?.linkedPlatformAccounts[0]?.platformCode;
    openNewTab(`${platformCode === 'SDK_INVESTWELL' ? WhatsAppLink.helpPartnerSDK_INVESTWELL : WhatsAppLink.helpPartner}`, OpenNewTabTargetType.blank);
};
export const GoToPhone = async (action, _datastore, { openNewTab, instrumentTrack, asyncStorage }) => {
    instrumentTrack("CONTACT_VIA_CALL_BUTTON_CLICKED");
    const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const platformCode = _user?.linkedPlatformAccounts[0]?.platformCode;
    const partnerAccountType = action.payload.partnerAccountType ? action.payload.partnerAccountType : _user?.linkedPlatformAccounts[0]?.platformCode;
    if (partnerAccountType === PartnerAccountType.AFFILIATE) {
        openNewTab(`tel:+91${partnerAffiliateHelpLineNumber}`, OpenNewTabTargetType.parent);
    }
    else {
        openNewTab(`tel:+91${platformCode === 'SDK_INVESTWELL' ?
            SDKInvestwellPartnerHelpLineNumber :
            partnerHelpLineNumber}`, OpenNewTabTargetType.parent);
    }
};
export const CityGoBack = async (action, _datastore, { setDatastore }) => {
    console.warn('**** CityGoBack Triggered ****', action);
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'additionalDetailContainer', {
        hide: false,
    });
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'citySelectionContainer', {
        hide: true,
    });
};
export const ArnSelectAction = async (action, _datastore, { setDatastore }) => {
    console.warn('**** ArnSelectAction Triggered ****', action);
    const value = action?.payload?.value;
    if (value) {
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'arnDetailsContainerContinue', {
            type: ButtonTypeTokens.LargeOutline
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'haveARNSelectContainerRadio1', {
            name: IconTokens.RadioCircleFilled
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'dontARNSelectContainerRadio1', {
            name: IconTokens.RadioCircleNotFilled
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'arnDetailContainerInputStack', {
            hide: false
        });
    }
    else {
        arnNo = '';
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'haveARNSelectContainerRadio1', {
            name: IconTokens.RadioCircleNotFilled
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'dontARNSelectContainerRadio1', {
            name: IconTokens.RadioCircleFilled
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'arnDetailContainerInputStack', {
            hide: true
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'arnDetailsContainerContinue', {
            type: ButtonTypeTokens.LargeFilled
        });
    }
};
export const ArnInputAction = async (action, _datastore, { setDatastore }) => {
    arnNo = action?.payload?.value;
    if (arnNo.length >= 1 && arnNo.length <= 6) {
        //active the button
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'arnDetailsContainerContinue', {
            type: ButtonTypeTokens.LargeFilled
        });
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'arnDetailContainerInput', {
            state: InputStateToken.SUCCESS,
            showErrorOnFocus: false
        });
    }
    else {
        //keep the button deactivated
        if (arnNo.length > 6) {
            await setDatastore(ROUTE.PARTNER_SIGNUP, 'arnDetailContainerInput', {
                state: InputStateToken.ERROR,
                showErrorOnFocus: true
            });
        }
        await setDatastore(ROUTE.PARTNER_SIGNUP, 'arnDetailsContainerContinue', {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const ArnSubmitAction = async (action, _datastore, { setDatastore, navigate, network, analytics }) => {
    console.warn('**** ArnSubmitAction Triggered ****', action);
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'arnDetailsContainerContinue', {
        loading: true
    });
    // first update the ARN
    const partnerUserContext = JSON.parse(await AsyncStorage.getItem(StoreKey.userContext));
    const partnerAccountId = partnerUserContext?.linkedPartnerAccounts[0]?.accountId;
    const header = await getAppHeader();
    header['X-AppPlatform'] = await SharedPropsService.getAppPlatform();
    const updateUserDetails = {
        accountHolderEmail: email,
        address: {
            city: city
        },
        partnerName: name,
        partnerProfileDetails: {
            companyName: companyName,
            arnNo: arnNo
        }
    };
    const response = await network.patch(`${partnerApi.accountAttributes}${partnerAccountId}`, updateUserDetails, {
        headers: header
    });
    // On success open the empanel modal
    if (response?.status === 200) {
        analytics('mfd_empanelment_complete', {});
        await navigate(ROUTE.EMPANEL_SUCCESS_MODAL, { referredPartner: referredPartner });
    }
    await setDatastore(ROUTE.PARTNER_SIGNUP, 'arnDetailsContainerContinue', {
        loading: false
    });
};
export const goToPrivacyAction = async (action, _datastore, { openNewTab }) => {
    const privacyLink = getPrivacyLinks();
    openNewTab(privacyLink, OpenNewTabTargetType.blank);
};
export const goToTermAction = async (action, _datastore, { openNewTab }) => {
    const termsLink = getTermsLinks();
    openNewTab(termsLink, OpenNewTabTargetType.blank);
};
